import {ApiError, ApiService} from "@/services/api.service";
import {Constants} from "@/constants";

class BookingFile {
    constructor(name) {
        this.name = name.split("/").pop("");
        this.removed = false;
    }
}

const FileService = {

    sendBookingFile: async function(file, customerID, bookingID) {
        try {
            if (!file instanceof File) {
                throw new Error("Not a file");
            }
            const endpoint = `${Constants.ENDPOINT_FILEHANDLER}/${customerID}/${bookingID}`;
            const response = await ApiService.postFile(endpoint, file);
        }
        catch (error) {
            throw new ApiError(error);
        }
    },

    getBookingFiles: async function(customerID, bookingID) {
        try {
            const endpoint = `${Constants.ENDPOINT_FILEHANDLER}/${customerID}/${bookingID}`;
            return await ApiService.get(endpoint);
        } catch (err) {
            throw new ApiError(error)
        }
    },

    removeBookingFile: async function(filename, customerID, bookingID){
        try {
            const endpoint = `${Constants.ENDPOINT_FILEHANDLER}/${customerID}/${bookingID}/${filename}`;
            return await ApiService.delete(endpoint);
        } catch (err) {
            throw new ApiError(error)
        }
    },

    downloadFile: async function(filename, customerID, bookingID) {
        try {
            const endpoint = `${Constants.ENDPOINT_FILEHANDLER}/${customerID}/${bookingID}/${filename}`;
            const response =  await ApiService.getFile(endpoint);

            const fileURL = window.URL.createObjectURL(new Blob([response.data], {type: "image/jpg"}));
            const fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', filename);
            document.body.appendChild(fileLink);

            fileLink.click();
        } catch (e) {
            throw new ApiError(error)
        }
    }
}
export { FileService, BookingFile }
